import Text from '@components/Text';
import colors from '@constants/colors';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import useGoBack from '@hooks/useGoBack';
import ArrowLineLeft from '@icons/arrow/ArrowLineLeft';
import { IconProps } from '@models/icons';
import { pressActionEffect } from '@styles/mixin';
import { JSX, ReactNode } from 'react';

interface Props {
    title: string;
    backIcon?: (props: IconProps) => JSX.Element;
    trailing?: ReactNode;
    onBackClick?: () => void;
    noShadow?: boolean;
    noBackIcon?: boolean;
}

function Header(props: Props) {
    const {
        title, backIcon, trailing, onBackClick, noShadow, noBackIcon,
    } = props;
    const goBack = useGoBack();
    const BackIcon = backIcon || ArrowLineLeft;
    return (<Wrapper noShadow={noShadow}>
        <Container>
            {noBackIcon ? (
                <span/>
            ) : (<BackIcon size={30}
                color={colors.gray9}
                cursor='pointer'
                css={pressActionEffect}
                onClick={onBackClick ?? goBack}/>)}
            <Blank/>
            <Text fontWeight='medium'
                size='lg'
                color={colors.gray9}
                css={textCss}>
                {title}
            </Text>
            {trailing}
        </Container>
    </Wrapper>);
}

const Wrapper = styled.header<{
    noShadow?: boolean;
}>`
    background-color: var(--color-white);
    box-shadow: ${({ noShadow }) => (noShadow
        ? 'none' : '0 4px 6px 0 rgba(0, 0, 0, 0.15)')};
    height: calc(66px + var(--safe-area-top));
    left: 0;
    padding: calc(18px + var(--safe-area-top)) 18px 18px;
    position: sticky;
    top: 0;
    width: 100%;
    z-index: 10;  
`;

const Container = styled.nav`
    align-items: center;
    display: flex;
    height: 100%;
    justify-content: center;
    position: relative;
`;

const Blank = styled.div`
    flex:1;
`;

const textCss = css`
    position: absolute;
    transition: color 150ms;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: calc(100vw - 80px);
`;

export default Header;
